import { FormattedMessage } from 'react-intl';
import React from 'react';

export enum BadgeType {
  NO_DATA = 'N/A',
  SKILL_DEVELOPMENT = 'Skill Development',
  BRONZE = 'Bronze',
  SILVER = 'Silver',
  GOLD = 'Gold',
}

const DEV_NEEDED_LOWER_BAND = 50;
const DEV_NEEDED_UPPER_BAND = 62;

const BRONZE_LOWER_BAND = 62;
const BRONZE_UPPER_BAND = 75;

const SILVER_LOWER_BAND = 75;
const SILVER_UPPER_BAND = 88;

export const badgeTypeAssign = (score: string | null): BadgeType => {
  if (score === null) return BadgeType.NO_DATA;

  const castedScore = parseInt(score);

  if (
    castedScore >= DEV_NEEDED_LOWER_BAND &&
    castedScore < DEV_NEEDED_UPPER_BAND
  ) {
    return BadgeType.SKILL_DEVELOPMENT;
  } else if (
    castedScore >= BRONZE_LOWER_BAND &&
    castedScore < BRONZE_UPPER_BAND
  ) {
    return BadgeType.BRONZE;
  } else if (
    castedScore >= SILVER_LOWER_BAND &&
    castedScore < SILVER_UPPER_BAND
  ) {
    return BadgeType.SILVER;
  } else {
    return BadgeType.GOLD;
  }
};

export const improvementMessageRender = (score: string | null) => {
  const currentBadge = badgeTypeAssign(score);
  if (currentBadge === BadgeType.NO_DATA)
    return (
      <FormattedMessage
        id='cs_perfportal_qcs_improve_morePoints'
        defaultMessage='Complete more contacts to populate your QCS score.'
      />
    );

  const castedScore = parseInt(score!);
  let nextBadge;
  let improveScore;

  if (currentBadge === BadgeType.SKILL_DEVELOPMENT) {
    improveScore = DEV_NEEDED_UPPER_BAND - castedScore;
    nextBadge = BadgeType.BRONZE;
  } else if (currentBadge === BadgeType.BRONZE) {
    improveScore = BRONZE_UPPER_BAND - castedScore;
    nextBadge = BadgeType.SILVER;
  } else if (currentBadge === BadgeType.SILVER) {
    improveScore = SILVER_UPPER_BAND - castedScore;
    nextBadge = BadgeType.GOLD;
  }

  if (
    currentBadge === BadgeType.SKILL_DEVELOPMENT ||
    currentBadge === BadgeType.BRONZE ||
    currentBadge === BadgeType.SILVER
  ) {
    return (
      <FormattedMessage
        id='cs_perfportal_qcs_improvement'
        defaultMessage='Achieve <b>{improveScore}</b> more points in your QCS score to reach the <b>{nextBadge}</b> performance level.'
        values={{
          b: (...chunks: any) => <b>{chunks}</b>,
          improveScore,
          nextBadge,
        }}
      />
    );
  } else {
    return (
      <FormattedMessage
        id='cs_perfportal_qcs_improve_gold'
        defaultMessage='Congratulations! You have achieved the highest performance level.'
      />
    );
  }
};
